import React from 'react'

import clsx from 'clsx'

import DisplayComponent from 'components/Display'
import Icon from 'components/Icon'

import styles from './Display.module.scss'

/** @type {import("./types").default} */
const Display = ({ className, display, subscript = '/5', variant = 'large' }) => {
  return (
    <div className={clsx('Display', styles.root, className)}>
      <Icon icon="star" className={styles.icon} size="24" />
      <DisplayComponent display={display} subscript={subscript} variant={variant} />
    </div>
  )
}

export default Display
